import React from 'react';

export default ({ value, onChange }) => (
  <div className="input-group form-group">
    <div className="input-group-prepend">
      <span className="input-group-text"><i className="fas fa-user" /></span>
    </div>
    <input
      type="text"
      className="form-control"
      placeholder="email"
      name="email"
      value={value}
      onChange={onChange}
    />
  </div>
);
